// app/javascript/controllers/audio_controller.js
import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["toggle", "typeField"]
    static values = {
        name: String,
        multiple: Boolean,
        text: String,
    }

    connect() {
        this.recording = false
        this.chunks = []
        this.records = [];
    }

    async toggle() {
        if (!this.recording) {
            await this.start()
        } else {
            await this.stop()
        }
    }

    async start() {
        try {
            this.stream = await navigator.mediaDevices.getUserMedia({audio: true})
            this.recorder = new MediaRecorder(this.stream)
            this.chunks = []
            this.recorder.ondataavailable = e => this.chunks.push(e.data)
            this.recorder.onstop = () => this.attach()
            this.recorder.start()
            this.recording = true
            this.toggleTarget.textContent = "⏹️"
        } catch (e) {
            console.log(e);
            console.log(e);
            console.log(e);
            alert("Microphone permission is required to record audio.")
        }
    }

    async stop() {
        this.recorder.stop()
        this.stream.getTracks().forEach(t => t.stop())
        this.recording = false
        setTimeout(() => {
            let text = " Record 🎙️ ";
            if (this.records.length) {
                text += `(${this.records.length} records)`
            }
            this.toggleTarget.textContent = text;
        })

    }

    attach() {
        const blob = new Blob(this.chunks, {type: "audio/webm"})
        const file = new File([blob], `voice_${Date.now()}.webm`, {type: "audio/webm"})
        this.records.push(file);
        // Set the file to the hidden input
        const fileInput = this.element.querySelector(`input[name='${this.nameValue}']`);
        if (!this.element.querySelector('#audio_recordset')) {
            // Create a new recordset container
            const recordsetContainer = document.createElement('div');
            recordsetContainer.innerHTML = `<input id="audio_recordset_files" type="file" name="` + (this.nameValue || 'audio[]' )  + `" class="hidden" />`
            this.element.append(recordsetContainer);
        }
        // get record set files and append to hidden input
        const recordset = this.element.querySelector('#audio_recordset_files');

        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        recordset.files = dataTransfer.files;

        if (this.submitUrl) {
            this.element.submit();
        }
    }
}